<template>
  <div class="my-news">
    <div class="banner">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="item in photo" :key="item.id"
          ><img :src="item.photo" alt=""
        /></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="groupNews">
      <div class="gnTitle">
        <div class="gnTit"><div class="orange"></div><h5>集团新闻</h5></div>
        <div class="more" @click="routeServer('/groupNews')">查看更多<span><img src="../../assets/images/leftIcon.png" alt="" /></span> </div>
      </div>
      <div>
        <div v-for="item in newsLists" :key="item.id" class="newsPart" @click="newsRoute(item)">
          <div class="time">{{ item.time }}</div>
          <div class="newsText">{{ item.laiyuan }} | {{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="ourProject">
      <div class="gnTitle">
        <div class="gnTit"><div class="orange"></div><h5>BUSINESS<span> SEGMENTS</span></h5></div>
      </div>
      <div class="proCont">
        <div class="proPart" v-for="item in lists" :key="item.id" @click="routeServer(item.path)">
          <img :src="item.img" alt="">
        </div>
      </div>
      <div class="layOut" v-for='item in layout' :key='item.id' @click='routeLayout(item.path)'>
        <div class="sTitle">Strategic Layout</div>
        <div class="layTitle">战略布局</div>
        <div class="layTxt">爱情地产战略布局京津冀城市群、长三角城市群、华中城市群、成渝城市群、粤港澳大湾区五大城市群的21个强二线城市</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetHomeData } from "../../api/index";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import 'swiper/css/swiper.css'

export default {
  name: "index",
  metaInfo: {
    title: '爱情地产',
    meta: [{
      name: 'keyWords',
      content: '爱情地产'
    },
    {
      name: 'description',
      content: ''
    }]
  },
  data() {
    return {
       lists: [
        {
          id: 0,
          img:require('../../assets/images/indexImg1.png'),
          path: '/house'
        },
        {
          id: 1,
          img:require('../../assets/images/indexImg2.png'),
          path: '/business'
        },
        {
          id: 2,
           img:require('../../assets/images/indexImg3.png'),
          path: '/propertyService'
        },
      ],
      layout:[
        {
          title:'战略布局',
          path: '/strategic'
        }
      ],
      media: [],
      newsLists: [],
      photo: [],
      swiperOptions: {
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },
  methods:{
    newsRoute(item) {
      this.$router.push({
        name: "newsDetails",
        params: {
          id: item.id,
        },
      });
    },
    routeServer(path){
      this.$router.push({
        path:path,
      })
    },
    routeLayout(path){
      this.$router.push({
        path:path,
      })
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    apiGetHomeData().then((data) => {
      if (data.data.status == 1) {
        this.newsLists = data.data.news["new"];
        this.newsLists.forEach((item) => {
          let date = new Date(item.create_time * 1000);
          item.time = [date.getFullYear(), date.getMonth()+1, date.getDate()]
            .map((res) => (res + "").padStart(2, "0"))
            .join("/");
        });
        data.data.photo.forEach((item) => {
          item.id = item.id * 1 - 1;
          item.photo = "http://www.weaiove.com" + item.photo;
        });
        this.photo = data.data.photo;
      }
    });
  },
};
</script>

<style scoped lang="less">
img {
  width: 100%;
  height: 100%;
}
.banner{
  width: 100%;
  height: 187.5px;
  overflow: hidden;
  .swiper-container{
    width: 100%;
    height: 100%;
  }
}
.groupNews{
  padding: 22px 15px 0;
}
.gnTitle{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 19px;
  .gnTit{
    font-family: 'DIN Alternate Bold';
    font-size: 18px;
    line-height: 25px;
    color: #333;
    margin: 0;
    font-weight: bold;
    position: relative;
    .orange{
      display: inline-block;
      width: 33px;
      height: 10px;
      background: #EE6A09;
      opacity: 0.8;
      position: absolute;
    }
    h5{
      font-size: 18px;
      line-height: 25px;
      color: #333;
      font-family: 'DIN Alternate Bold';
      z-index: 99;
      position: relative;
      font-weight: 600;
      margin: 0;
      letter-spacing: 0;
    }
    span{
      color: #E95506;
    }
  }
.more{
      font-family: '苹方-简 常规体';
      color: #999999;
      font-size: 13px;
      line-height: 18px;
      // margin-top: 6px;
      span{
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-left: 5px;
      }
    }
}
.newsPart{
  padding: 9px 15px 18px;
  background: #F4F4F4;
  border-radius: 5px;
  margin-bottom: 10px;
}
.newsPart .time{
  font-family: '苹方-简 常规体';
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 5px;
  color: #999;
}
.newsPart .newsText{
  font-family: '苹方-简 中黑体';
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}
.ourProject{
  font-family: 'DIN Alternate Bold';
  padding: 16px 15px 19px;
}
.proPart{
  margin-bottom: 12px;
  border-radius: 5px;
  
}
.layOut{
  padding: 28px 44px 28px 45px;
  background: url('../../assets/images/layOut.png') no-repeat top left;
  background-size: 100% 100%;
  text-align: center;
  margin-top: 17px;
}
.layOut .sTitle{
  font-family: '苹方-简 中黑体';
  font-size: 15px;
  line-height: 21px;
  color: #E95506;
  opacity: 0.79;
}
.layOut .layTitle{
  color: #E95506;
  font-family: '苹方-简 中黑体';
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}
.layOut .layTxt{
  color: #E95506;
  font-size: 13px;
  line-height: 18px;
  opacity: 0.6;
  font-family: '苹方-简 常规体';
  margin-top: 16px;
}
</style>
